/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description FeeType
 */

export enum FeeType {
  /** any fee that does not fall under the below categories */
  OTHER = 0,
  /** administrative fees */
  ADMIN = 1,
  /** application fees */
  APPLICATION = 2,
  /** security deposit */
  SECURITY_DEPOSIT = 3,
}

Object.defineProperty(FeeType, '__ENUM_NAME', {
  value: 'FeeType',
  writable: false,
  configurable: false,
  enumerable: false,
})
